import {
  extendTheme,
  withDefaultColorScheme,
  withDefaultProps,
} from "@chakra-ui/react";
// import "@fontsource/ibm-plex-sans";

const colors = {
  near: {
    50: "#E6FFFA",
    100: "#B2F5EA",
    200: "#2FA8AF",
    300: "#4FD1C5",
    400: "#38B2AC",
    500: "#2FA8AF",
    600: "#2C7A7B",
    700: "#285E61",
    800: "#234E52",
    900: "#1D4044",
  },
};

export const customTheme: any = extendTheme(
  {
    fonts: {
      body: `"IBM Plex Sans", Montserrat, -apple-system, BlinkMacSystemFont, Roboto, sans-serif;`,
      heading: `"IBM Plex Sans", Montserrat, -apple-system, BlinkMacSystemFont, Roboto, sans-serif;`,
      mono: `"IBM Plex Sans", Montserrat, -apple-system, BlinkMacSystemFont, Roboto, sans-serif;`,
    },
    colors,
    breakpoints: {
      base: "0em",
      sm: "599px",
      md: "48em",
      lg: "62em",
      xl: "80em",
      "2xl": "96em",
    },
    config: {
      initialColorMode: "light",
    },
    semanticTokens: {
      colors: {
        Light: {
          default: "#FFFFFF",
        },
        Blockchain_Near: {
          default: "#2FA8AF",
        },
        Blockchain_Aurora: {
          default: "#6FD24D",
        },
        Text_Main: {
          default: "#000000",
          _dark: "#FFFFFF",
        },
        Text_Sec: {
          default: "#5E5F64",
          _dark: "#8F8F8F",
        },
        Text_Ter: {
          default: "#ACB2B5",
          _dark: "#766A6A",
        },
        Base_Canvas: {
          default: "#F5F5F7",
          _dark: "#202022",
        },
        Base_Card: {
          default: "#FFFFFF",
          _dark: "#2C2C2E",
        },
        Secondary_Card: {
          default: "#F5F5F7",
          _dark: "#202022",
        },
        Base_Divider: {
          default: "#EEEFF4",
          _dark: "#424242",
        },
        Base_Divider_Inverse: {
          default: "#424242",
          _dark: "#EEEFF4",
        },
        Base_Overlay: {
          default: "rgba(6, 7, 16, 0.5)",
          _dark: "rgba(0, 0, 0, 0.8)",
        },
        Base_Disabled_Bg: {
          default: "#EEEFF4",
          _dark: "#1D1D1D",
        },
        Base_Disabled_Color: {
          default: "#ACB2B5",
          _dark: "#766A6A",
        },
        Success_Main: {
          default: "#38A169",
          _dark: "rgba(37, 133, 90, 0.5)",
        },
        Success_Main_1: {
          default: "#F0FFF4",
          _dark: "#9AE6B4",
        },
        Error_Main: {
          default: "#E53E3E",
          _dark: "rgba(197, 48, 48, 0.5)",
        },
        Error_Main_1: {
          default: "#FFF5F5",
          _dark: "#FEB2B2",
        },
        Warning_Main: {
          default: "#ECC94B",
          _dark: "rgba(236, 201, 75, 0.6)",
        },
        Warning_Main_1: {
          default: "#FFFFF0",
          _dark: "#FBD38D",
        },
        Notificaton_Main: {
          default: "#3182CE",
          _dark: "rgba(49, 130, 206, 0.5)",
        },
        Notificaton_Main_1: {
          default: "#F0FFF4",
          _dark: "#9AE6B4",
        },
        Base_Canvas_Bg: {
          default: "#F5F5F7",
          _dark: "#202022",
        },
      },
    },
  },
  withDefaultColorScheme({
    colorScheme: "near",
    components: ["Button"],
  }),
  withDefaultProps({
    defaultProps: {
      backgroundColor: "#2FA8AF",
      color: "#FFFFFF",
    },
    components: ["Button"],
  })
);
